import { apiClient } from './authService';

const companyService = {
  // Read the company master data (any authenticated user).
  getSettings: async () => {
    const res = await apiClient.get('company/settings/');
    return res.data;
  },

  // Admin only: update identity + pricing fields (JSON, no file).
  updateSettings: async (data) => {
    const res = await apiClient.patch('company/settings/', data);
    return res.data;
  },

  // Admin only: upload the logo on its own (multipart).
  uploadLogo: async (file) => {
    const formData = new FormData();
    formData.append('logo', file);
    const res = await apiClient.patch('company/settings/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  },
};

export default companyService;
